export const XOSIMAGE_FORM = 'xosimages';
export const TAB_INDEX = '1000';
export const EMPTY_VALUE = '';

export enum FormNames {
  HOB_CODES = 'hobCodes',
  COUNTY = 'hobCodes.сountyHob',
  DISTRICT = 'hobCodes.districtCode',
  STATE = 'hobCodes.stateHob',
}

export enum FieldGroupNames {
  INDIVIDUALS = 'individuals',
  CORPORATIONS = 'corporations',
}

export enum SearchByNames {
  SEARCH_BY = 'searchBy',
  INDIVIDUAL = 'individual',
  CORPORATION = 'corporation',
}

export enum XosImageFormLabels {
  STATE = 'State',
  COUNTY = 'County',
  DISTRICT = 'District',
}

export enum XosImageFormPlaceholders {
  COUNTY = 'All Counties',
  STATE = 'Choose State',
  DISTRICT = 'All Districts',
}

export const INDIVIDUAL_INITIAL_VALUES = {
  firstName: EMPTY_VALUE,
  middleName: EMPTY_VALUE,
  lastName: EMPTY_VALUE,
  bankruptcySearch: false,
  patriotSearch: false,
};

export const CORPORATIONS_INITIAL_VALUES = {
  corporationName: EMPTY_VALUE,
  bankruptcySearch: false,
  patriotSearch: false,
};

export const XOSIMAGE_FORM_INITIAL_ITEM_GROUP = {
  [FormNames.HOB_CODES]: {
    stateHob: EMPTY_VALUE,
    сountyHob: EMPTY_VALUE,
    districtCode: EMPTY_VALUE,
  },
  [FieldGroupNames.INDIVIDUALS]: [INDIVIDUAL_INITIAL_VALUES],
  [FieldGroupNames.CORPORATIONS]: [CORPORATIONS_INITIAL_VALUES],
};

export const XOSIMAGE_FORM_INITIAL_VALUES = {
  items: [XOSIMAGE_FORM_INITIAL_ITEM_GROUP],
};
